import { IAppState } from 'shared/common/state';

export const isErrorOpenedSelector = (state: IAppState): boolean => {
  return state.consultantCianChat.isErrorPopupOpened;
};
